( function ( _s ) {
	_s.fn.shopDonateDropdown = function () {
		return this.each( shopDonateDropdown => {
			const _shopDonateDropdown = _s( shopDonateDropdown );
			const _toggle = _shopDonateDropdown.find( '.toggle' );
			const _toggleIcon = _toggle.find( '.toggle-icon' );
			const _mainLink = _shopDonateDropdown.find( '.main-link a' );
			const _dropdownLinks = _shopDonateDropdown.find( '.dropdown-items a' );
			const isDesktopHeaderDropdown = _shopDonateDropdown.closest( '.navbar-desktop' ).length;
			const _desktopSearchForm = _shopDonateDropdown
				.closest( '.navbar-desktop' )
				.find( '.fr-search-form' );

			const toggle = () => {
				_shopDonateDropdown.toggleClass( 'show' );

				if ( _shopDonateDropdown.hasClass( 'show' ) ) {
					triggerExpandedEvent();
				}
			};

			const show = () => {
				_shopDonateDropdown.addClass( 'show' );
				triggerExpandedEvent();
			};

			const hide = () => {
				_shopDonateDropdown.removeClass( 'show' );
			};

			const checkBlur = target => {
				const _target = _s( target );

				if ( ! _shopDonateDropdown.contains( _target ) ) {
					hide();
				}
			};

			const triggerExpandedEvent = () => {
				_s( window ).trigger( 'fr:shop-donate-dropdown-expanded' );
			};

			if ( isDesktopHeaderDropdown ) {
				_toggleIcon.on( 'keyup', e => {
					if ( e.key === 'Enter' ) {
						toggle();
					}
				} );

				_shopDonateDropdown.on( 'mouseenter', e => {
					setTimeout(
						() => {
							if ( _shopDonateDropdown.filter( ':hover' ).length ) {
								show();
							}
						},
						_desktopSearchForm.hasClass( 'show-form' ) ? 250 : 0
					);
				} );

				_shopDonateDropdown.on( 'mouseleave', e => {
					hide();
				} );
			}

			if ( ! isDesktopHeaderDropdown ) {
				_toggle.on( 'click', () => {
					toggle();
				} );
			}

			_dropdownLinks.on( 'keydown', e => {
				if ( ! [ 'ArrowUp', 'ArrowDown' ].includes( e.key ) ) return;

				e.preventDefault();

				const _currentItem = _s( e.target );
				const isLast = _currentItem.filter( ':last-child' ).length;
				const isFirst = _currentItem.filter( ':first-child' ).length;

				if ( e.key === 'ArrowDown' ) {
					if ( isLast ) return;
					_currentItem.firstElement().nextElementSibling.focus();
				}

				if ( e.key === 'ArrowUp' ) {
					if ( isFirst ) {
						_mainLink.firstElement().focus();
					} else {
						_currentItem.firstElement().previousElementSibling.focus();
					}
				}
			} );

			_dropdownLinks.add( _mainLink.firstElement() ).on( 'blur', e => {
				if ( e.relatedTarget ) {
					checkBlur( e.relatedTarget );
				}
			} );

			_toggleIcon.add( _mainLink.firstElement() ).on( 'keydown', e => {
				if ( ! [ 'ArrowUp', 'ArrowDown' ].includes( e.key ) ) return;

				e.preventDefault();

				if ( e.key === 'ArrowDown' ) {
					_dropdownLinks.filter( ':first-child' ).firstElement().focus();
				}
			} );

			_s( window ).on( 'fr:body-click', e => {
				if ( ! isDesktopHeaderDropdown ) return;

				checkBlur( e.detail.event.target );
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '.shop-donate-dropdown' ).shopDonateDropdown();
	} );
} )( window._s );
